"use strict";

var _interopRequireDefault = require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isExternal = isExternal;
exports.validateThemeName = exports.validateTagName = exports.validateKeyword = void 0;

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.regexp.test.js");

var _regular = _interopRequireDefault(require("./regular.js"));

/**
 * @param {string} path
 * @returns {Boolean}
 */
function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path);
}
/**
 * @param {string} str
 * @returns {Boolean}
 */
// export function validUsername(str) {
//   const valid_map = ['admin', 'editor']
//   return valid_map.indexOf(str.trim()) >= 0
// }
// export function validUsername(str) {
//   const res = /^(13[0-9]|14[5-9]|15[012356789]|166|17[0-8]|18[0-9]|19[8-9])[0-9]{8}$/
//   return res.test(str)
// }
// export function validatePassword(str) {
//   const res = /(?!^\d+$)(?!^[A-Za-z]+$)(?!^[^A-Za-z0-9]+$)(?!^.*[\u4E00-\u9FA5].*$)^\S{6,14}$/
//   return res.test(str)
// }
// // 验证修改密码
// export function resetPassword(rule, value, callback) {
//   if (value == undefined || value == null || value == '') {
//     callback(new Error('请输入密码'))
//   } else if (!Regular.isPassword(value)) {
//     callback(new Error('请输入6位以上的数字、字母！'))
//   } else {
//     callback()
//   }
// }
// // 验证固话或者手机号
// export function validateFixedTel(rule, value, callback) {
//   if (value == undefined || value == null || value == '') {
//     callback(new Error('请输入联系电话'))
//   } else if (Regular.isFixedTel(value) || Regular.isMobile(value)) {
//     callback()
//   } else {
//     callback(new Error('请输入正确格式的固话或手机号码！'))
//   }
// }
// // 验证手机号码
// export function validateMobile(rule, value, callback) {
//   if (value == undefined || value == null || value == '') {
//     callback(new Error('请输入手机号码'))
//   } else if (!Regular.isMobile(value)) {
//     callback(new Error('请输入正确格式的手机号码！'))
//   } else {
//     callback()
//   }
// }
// // 验证姓名
// export function validateName(rule, value, callback) {
//   if (value == undefined || value == null || value == '') {
//     callback(new Error('请输入姓名'))
//   } else if (!Regular.checkName(value)) {
//     callback(new Error('请输入10个字符长度以内的字母或汉字！'))
//   } else {
//     callback()
//   }
// }


var checkChineseAndLetter = function checkChineseAndLetter(rule, value, callback) {
  var reg = /^[A-Za-z\u4E00-\u9FA5]+$/;

  if (!value) {
    callback();
  } else {
    if (reg.test(value)) {
      callback();
    } else {
      callback(new Error('请输入中文或者英文字母大小写'));
    }
  }
};

var validateThemeName = [{
  required: true,
  trigger: 'blur',
  message: "\u8BF7\u8F93\u5165\u9898\u6750\u540D\u79F0"
}, {
  required: true,
  min: 1,
  max: 10,
  message: '请输入1-10个字符',
  trigger: 'blur'
}, {
  required: true,
  validator: checkChineseAndLetter,
  trigger: 'blur'
}];
exports.validateThemeName = validateThemeName;
var validateKeyword = [{
  required: true,
  trigger: 'blur',
  message: "\u8BF7\u8F93\u5165\u5173\u952E\u8BCD"
}, {
  required: true,
  min: 1,
  max: 10,
  message: '请输入1-10个字符',
  trigger: 'blur'
}, {
  required: true,
  validator: checkChineseAndLetter,
  trigger: 'blur'
}];
exports.validateKeyword = validateKeyword;
var validateTagName = [{
  required: true,
  trigger: 'blur',
  message: "\u8BF7\u8F93\u5165\u5206\u7C7B\u540D\u79F0"
}, {
  required: true,
  min: 1,
  max: 16,
  message: '请输入1-16个字符',
  trigger: 'blur'
}];
exports.validateTagName = validateTagName;